var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeContactDetails',_vm._b({},'ChangeContactDetails',_vm.componentData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }